"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DELETE_CONTRACT_CONFIRMATION_MESSAGE = void 0;
exports.DELETE_CONTRACT_CONFIRMATION_MESSAGE = 'Only delete contracts that were created in error. A full contract history is necessary to calculate payout based on the pay structure at any given attribution date. It is also important for reporting purposes to track performance impacts of evolving deal structures.';
